(function () {
  function initGallery(galleryEl) {
    if (!galleryEl || galleryEl.dataset.galleryInit === 'true') return;
    galleryEl.dataset.galleryInit = 'true';

    var galleryId = galleryEl.id;
    var hasThumbs = galleryEl.querySelector('.upqode-gallery__thumbs');

    var thumbsSwiper = null;
    if (hasThumbs) {
      thumbsSwiper = new Swiper('#' + galleryId + '-thumbs', {
        slidesPerView: 3,
        spaceBetween: 10,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          1025: {
            spaceBetween: 20,
          },
        },
      });
    }

    var mainSwiper = new Swiper('#' + galleryId + '-main', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        prevEl: '#' + galleryId + '-prev',
        nextEl: '#' + galleryId + '-next',
      },
      pagination: {
        el: '#' + galleryId + '-pagination',
        clickable: true,
        type: 'bullets',
      },
      thumbs: hasThumbs ? { swiper: thumbsSwiper } : undefined,
    });

    /* ── Lightbox popup on slide click ── */
    if (typeof GLightbox !== 'undefined') {
      var slideEls = Array.prototype.slice.call(
        galleryEl.querySelectorAll('.upqode-gallery__main .swiper-slide')
      );

      var lightboxElements = slideEls.map(function (slide) {
        return {
          href: slide.dataset.fullUrl,
          type: 'image',
          alt: slide.dataset.alt || '',
        };
      });

      var lightbox = GLightbox({
        elements: lightboxElements,
        loop: true,
        touchNavigation: true,
        zoomable: true,
      });

      /* Don't fire the lightbox after a drag/swipe — only on a real tap/click */
      var downX = 0;
      var downY = 0;
      var DRAG_THRESHOLD = 8;

      slideEls.forEach(function (slide, index) {
        slide.style.cursor = 'zoom-in';

        slide.addEventListener('pointerdown', function (e) {
          downX = e.clientX;
          downY = e.clientY;
        });

        slide.addEventListener('click', function (e) {
          if (
            Math.abs(e.clientX - downX) > DRAG_THRESHOLD ||
            Math.abs(e.clientY - downY) > DRAG_THRESHOLD
          ) {
            return;
          }
          lightbox.openAt(index);
        });
      });
    }

    /* Sync with Shopify variant change */
    document.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.featured_media) return;
      var mediaId = variant.featured_media.id;
      var slides = galleryEl.querySelectorAll('.upqode-gallery__main .swiper-slide');
      slides.forEach(function (slide, i) {
        if (slide.dataset.mediaId == mediaId) {
          mainSwiper.slideTo(i, 0);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.upqode-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
